import { config } from '@iheartjane/config';

import { request } from '@jane/monolith/utils/request';

interface User {
  app_mode_at_registration?: string;
  current_password?: string;
  password?: string;
  password_confirmation?: string;
  store_id_at_registration?: string | number;
}

type UserProps = {
  promotions_opt_out?: boolean;
  user: User;
};

export class UsersSource {
  static urlRoot = `${config.apiPath}/users`;

  static update(user: UserProps) {
    return request(this.urlRoot, {
      body: JSON.stringify(user),
      method: 'PUT',
    });
  }
}
